import logger from '../../utils/logger';
import { Component } from 'react';
import { ErrorBoundaryProps, ErrorBoundaryState } from '../../types/error';


class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack: string }): void {
    logger('error', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        this.props.fallback ?? null
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
